<template>
  <div>
    <div class="container" v-if="customer">
      <!-- 客户信息 -->
      <div class="card">
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-post"></use>
          </svg>
          <span>{{customer.custName}}</span>
          <!-- <van-tag type="primary">{{formatHandel('custStatus',customer.custStatus)}}</van-tag> -->
        </div>
        <div class="tag_box">
          <van-tag type="primary" v-if="customer.custStatus">{{ formatHandel('custStatus',customer.custStatus) }}</van-tag>
          <van-tag type="primary" v-if="customer.custSource">{{ formatHandel('custSource',customer.custSource) }}</van-tag>
          <van-tag type="primary" v-if="customer.custLevel">{{ formatHandel('custLevel',customer.custLevel) }}</van-tag>
          <van-tag type="primary" v-if="customer.unitNature">{{ formatHandel('unitNature',customer.unitNature) }}</van-tag>
          <van-tag type="primary" v-if="customer.industryNam">{{ customer.industryName }}</van-tag>
        </div>
        <div class="list-wrap van-hairline--top">
          <div class="item" style="width: 50%;">
            <span class="key">客户ID：</span>
            <span class="value">{{ customer.custCode }}</span>
          </div>
          <!-- <div class="item" style="width: 50%;">
            <span class="key">合作产品：</span>
            <span class="value">{{ customer.mainProducts  || '-' }}</span>
          </div> -->
          <div class="item">
            <span class="key">地址：</span>
            <span class="value">{{customer.custAddress || '-'}}</span>
          </div>
          <div class="item">
            <span class="key">跟进：</span>
            <span class="value">{{customer.deptName}}    {{customer.userName}}</span>
          </div>
        </div>
        <div class="middle_content" v-if="customer.status == 0" v-html="backLogInfo.content">
          <!-- 张三2022-10-17 10:12申请认领公海客户【湖南三亚科技有限公司】，请速确认。 -->
          <!-- {{backLogInfo.content}} -->
        </div>
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;" v-if="customer.status == 0">
          <van-cell title="审核状态" required>
            <template>
              <van-radio-group v-model="form.verifyStatus" direction="horizontal">
                <van-radio name="1" clickable @click="form.verifyStatus = '1'">通过</van-radio>
                <van-radio name="2" clickable @click="form.verifyStatus = '2'">未通过</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-model="form.content"
            autosize
            label="审核意见"
            placeholder="审核状态为不通过时请填写审核意见"
            type="textarea"
            show-word-limit
            :required="form.verifyStatus == '2'?true:false"
            :rules="form.verifyStatus == '2'?[{ required: true }]:[]"/>
        </van-form>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="1" v-if="customer.status == 0">
        <van-grid-item>
          <div class="flex-center" @click="confirm">
            <van-icon name="certificate" size="22" color="#1989fa" />
            <span>确认并处理下一条</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>

<script>
import { getCust, getSourceTree, batchApproval, auditApply } from '@/api/scrm/mycust'
import { listBacklog } from '@/api/admi/user'
// import { addContact } from '@/api/scrm/custcontact'
import { Toast, Dialog } from 'vant'

export default {
  components: {
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      type: null, // 判断是处理什么数据
      contactsShow: false,
      add_show: false,
      contactsForm: {},
      visitShow: false,
      visitForm: {},
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      pattern: '/^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/',
      customer: { map: {} },
      // 修改客户
      editCustShow: false,
      // 是否显示弹框
      show: false,
      // 生日
      showBirthdayCalendar: false,
      // 证件类型
      showPopupPicker: false,
      active: 0,
      form: {
        ids: [],
        verifyStatus: '1',
        content: ''
      },
      // 客户操作日志
      operationLog: [],
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 业务类型树选项
        businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],
        // 性别状态字典
        sexOptions: this.$store.state.dictOptions.sex || []
      },

      backLogInfo: {}
    }
  },
  created() {
    this.getOptions()
    if (this.$route.query.type == 1) {
      this.type = 1
      this.form.ids.push(this.$route.query.customerShareId)
      this.getBacklog(this.$route.query.id)
    } else if (this.$route.query.type == 2) {
      this.type = 2
      this.form.ids.push(this.$route.query.highSeasApplyId)
      this.getBacklog(this.$route.query.id)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '客户审批'
      this.getCustomer()
    },
    getBacklog(id) {
      listBacklog({ bussId: id, backlogType: 1, childType: this.type, checkStatus: 0 }).then(res => {
        if (res.code == 200) {
          this.backLogInfo = res.rows[0]
        }
      })
    },
    async getCustomer() {
      const res = await getCust(this.$route.query.id)
      if (res.code === 200) {
        this.customer = res.data

        this.options.contactIdOptions = []
        const uLis = this.customer.contactList || []
        for (let i = 0; i < uLis.length; i++) {
          const element = uLis[i]
          const item = {
            dictValue: element.contactId,
            dictLabel: element.contactName
          }
          this.options.contactIdOptions.push(item)
        }
        this.options.boIdOptions = []
        const boLis = this.customer.boList || []
        for (let i = 0; i < boLis.length; i++) {
          const element = boLis[i]
          const item = {
            dictValue: element.boId,
            dictLabel: element.boName
          }
          this.options.boIdOptions.push(item)
        }
      }
      console.log(this.customer)
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    async confirm() {
      const that = this
      await this.$refs.form.validate()
      if (this.type == 1) {
        Dialog.confirm({
          title: '审核提示',
          message: '是否确认审核？'
        }).then(function() {
          return batchApproval(that.form)
        }).then((res) => {
          if (res.code == 200) {
            that.afterConfirm()
          } else {
            Toast.fail(res.msg)
          }
        })
      } else if (this.type == 2) {
        Dialog.confirm({
          title: '审核提示',
          message: '是否确认审核？'
        }).then(function() {
          return auditApply(that.form)
        }).then((res) => {
          if (res.code == 200) {
            that.afterConfirm()
          } else {
            Toast.fail(res.msg)
          }
        }).catch((res) => {
          Toast.fail(res.msg)
        })
      }
    },
    afterConfirm() {
      listBacklog({ backlogType: 1, checkStatus: 0 }).then(daiban => {
        if (daiban.rows.length > 0) {
          this.form.ids = []
          this.form.ids.push(daiban.rows[0].remark)
          this.type = daiban.rows[0].childType
          this.getBacklog(daiban.rows[0].bussId)
        } else {
          Toast.success('暂无客户待办数据')
          setTimeout(() => {
            this.$router.push({
              path: '/daiban',
              query: { type: 0 }
            })
          }, 500)
        }
      })
    },
    getOptions() {
      this.getDicts('crm_mycust_type').then(res => {
        this.options.custTypeOptions = res.data
      })
      this.getDicts('crm_scale').then(res => {
        this.options.scaleOptions = res.data
      })
      this.getDicts('crm_cust_status').then(res => {
        this.options.custStatusOptions = res.data
      })
      this.getDicts('crm_acquire_way').then(res => {
        this.options.acquireWayOptions = res.data
      })
      this.getDicts('crm_unit_nature').then(res => {
        this.options.unitNatureOptions = res.data || []
      })
      this.getDicts('crm_cust_level').then(res => {
        this.options.custLevelOptions = res.data
      })
      this.getDicts('crm_call_name').then(res => {
        this.options.callNameOptions = res.data
      })
      // this.getDicts('crm_cust_source').then(res => {
      //   this.options.custSourceOptions = res.data
      // })
      getSourceTree().then(res => {
        this.options.custSourceOptions = res.rows.map(item => { return { dictLabel: item.custSourceName, dictValue: item.custSourceId } })
      })
      // 证件类型
      this.getDicts('crm_ide_type').then(res => {
        this.options.ideTypeOptions = res.data
      })
      // 亲密度
      this.getDicts('crm_intimacy').then(res => {
        this.options.intimacyOptions = res.data
      })
      // 性别
      this.getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
      this.getDicts('crm_visit_type').then(res => {
        this.options.visitTypeOptions = res.data
      })
      // 性别
      this.getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
    },
    formatDate(date) { // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
/* 跟进记录 */
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
.cont-tab{
  overflow-y: hidden;
  // .pb(120);
}
// .concat-list{
//     // height: auto;
//     overflow: scroll;
// }

.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
.container{
  .card{
    min-height: 200px;
    .tag_box{
      .van-tag{
        margin-left: 12px;
      }
    }
  }
}
.middle_content{
  padding: 20px;
  border-top: 1px solid #c4c4c4;
  border-bottom: 1px dashed #c4c4c4;
  line-height: 60px;
  font-size: 26px;
  color: #666;
}
.van-cell__value {
  min-width: 71%; //可根据自己需求设定值
  text-align: left;
}
</style>
